import {
  JSResource,
  type SimpleEntryPoint,
} from "@loop-payments/react-router-relay";
import type { CustomerBillingsMonth } from "./CustomerBillingsMonth";
import CustomerBillingsMonthQueryNode, {
  type CustomerBillingsMonthQuery$variables,
} from "./__generated__/CustomerBillingsMonthQuery.graphql";

const entryPoint: SimpleEntryPoint<typeof CustomerBillingsMonth> = {
  root: JSResource("CustomerBillingsMonth", () =>
    import("./CustomerBillingsMonth").then(
      (module) => module.CustomerBillingsMonth,
    ),
  ),
  getPreloadProps({ params }) {
    const variables: CustomerBillingsMonthQuery$variables = {
      month: params.month!,
    };

    return {
      queries: {
        query: {
          parameters: CustomerBillingsMonthQueryNode,
          variables,
          options: {
            fetchPolicy: "store-and-network",
          },
        },
      },
    };
  },
};

export default entryPoint;
